import { LobbyPage } from "./pages/public/LobbyPage";
import { NewbiePage } from "./pages/public/NewbiePage";
import { CalculatorPage } from "./pages/public/CalculatorPage";
import { RedPacketPage } from "./pages/public/RedPacketPage";
import { GemsPage } from "./pages/public/GemsPage";
import { InvitePage } from "./pages/public/InvitePage";
import { InventoryPage } from "./pages/public/InventoryPage";
import { GraduateWeekPage } from "./pages/public/GraduateWeekPage";
import { WeeklyPassPage } from "./pages/public/WeeklyPassPage";
import { WeekendBoostPage } from "./pages/public/WeekendBoostPage";
import { WeekendBonusPage } from "./pages/public/WeekendBonusPage";
import { LevelPage } from "./pages/public/LevelPage";
import { LimitedChallengePage } from "./pages/public/LimitedChallengePage";
import { ProfilePage } from "./pages/public/ProfilePage";
import { RescuePage } from "./pages/public/RescuePage";
import { GroupCheckinPage } from "./pages/public/GroupCheckinPage";
import { AdminHomePage } from "./pages/admin/AdminHomePage";
import { AdminMembersPage } from "./pages/admin/AdminMembersPage";
import { AdminMemberDetailPage } from "./pages/admin/AdminMemberDetailPage";
import { AdminNewbiePage } from "./pages/admin/AdminNewbiePage";
import { AdminRewardsPage } from "./pages/admin/AdminRewardsPage";
import { AdminDepositsPage } from "./pages/admin/AdminDepositsPage";
import { AdminAssetsPage } from "./pages/admin/AdminAssetsPage";
import { AdminRedPacketPage } from "./pages/admin/AdminRedPacketPage";
import { AdminRedPacketV2Page } from "./pages/admin/AdminRedPacketV2Page";
import { AdminGemsPage } from "./pages/admin/AdminGemsPage";
import { AdminGloryValuePage } from "./pages/admin/AdminGloryValuePage";
import { AdminInvitePage } from "./pages/admin/AdminInvitePage";
import { AdminGraduateWeekPage } from "./pages/admin/AdminGraduateWeekPage";
import { AdminWeeklyPassPage } from "./pages/admin/AdminWeeklyPassPage";
import { AdminWeekendBoostPage } from "./pages/admin/AdminWeekendBoostPage";
import { AdminLevelPage } from "./pages/admin/AdminLevelPage";
import { AdminLimitedChallengePage } from "./pages/admin/AdminLimitedChallengePage";
import { AdminCrawlerPage } from "./pages/admin/AdminCrawlerPage";
import { AdminReportsPage } from "./pages/admin/AdminReportsPage";
import { AdminFinancePage } from "./pages/admin/AdminFinancePage";
import { AdminSettingsPage } from "./pages/admin/AdminSettingsPage";
import { AdminAuditLogPage } from "./pages/admin/AdminAuditLogPage";
import { AdminTestDataPage } from "./pages/admin/AdminTestDataPage";
import { AdminReviewsPage } from "./pages/admin/AdminReviewsPage";
import { isLocalDevFrontend } from "./lib/env";

export const routes: Record<string, () => JSX.Element> = {
  "/": LobbyPage,
  "/newbie": NewbiePage,
  "/calculator": CalculatorPage,
  "/red-packet": RedPacketPage,
  "/gems": GemsPage,
  "/invite": InvitePage,
  "/inventory": InventoryPage,
  "/graduate-week": GraduateWeekPage,
  "/weekly-pass": WeeklyPassPage,
  "/weekend-bonus": WeekendBonusPage,
  "/weekend-boost": WeekendBoostPage,
  "/level": LevelPage,
  "/limited-challenge": LimitedChallengePage,
  "/profile": ProfilePage,
  "/rescue": RescuePage,
  "/group-checkin": GroupCheckinPage,
  "/admin": AdminHomePage,
  "/admin/members": AdminMembersPage,
  "/admin/reviews": AdminReviewsPage,
  "/admin/newbie": AdminNewbiePage,
  "/admin/rewards": AdminRewardsPage,
  "/admin/deposits": AdminDepositsPage,
  "/admin/assets": AdminAssetsPage,
  "/admin/red-packet": AdminRedPacketPage,
  "/admin/red-packet-v2": AdminRedPacketV2Page,
  "/admin/gems": AdminGemsPage,
  "/admin/glory-value": AdminGloryValuePage,
  "/admin/invite": AdminInvitePage,
  "/admin/graduate-week": AdminGraduateWeekPage,
  "/admin/weekly-pass": AdminWeeklyPassPage,
  "/admin/weekend-boost": AdminWeekendBoostPage,
  "/admin/level": AdminLevelPage,
  "/admin/limited-challenge": AdminLimitedChallengePage,
  "/admin/crawler": AdminCrawlerPage,
  "/admin/reports": AdminReportsPage,
  "/admin/finance": AdminFinancePage,
  "/admin/settings": AdminSettingsPage,
  "/admin/logs": AdminAuditLogPage,
  "/admin/test-data": AdminTestDataPage,
  "/admin/audit-log": AdminAuditLogPage
};

export function resolveRoute(path: string) {
  if (path.startsWith("/admin/members/") && path.length > "/admin/members/".length) {
    return AdminMemberDetailPage;
  }
  if (path === "/admin/test-data" && !isLocalDevFrontend()) {
    return AdminHomePage;
  }
  return routes[path] ?? routes["/"];
}
